<script setup>
import { useMeta } from '~/composables/common/use-meta'
import { MODAL_LOGIN, MODAL_SIGN_UP } from '~/constants'
import { AuthTabEnum, RoutesEnum } from '~/enums'
import { useModalsStore } from '#lib/stores'
import { useMaintenanceSite } from '~/composables/common/use-maintenance-site'
import { LOGIN_REQUIRED_REDIRECT } from './resources/common'
import { IFrameGameURLEnum } from '@kira-dancer/nuxt-common/enums'
import { useJsonLd } from '~/composables/common/use-json-ld'

const { displayedLayout } = useMaintenanceSite()
const { currentMeta } = useMeta()
const { isLogged } = useUser()
const route = useRoute()
const { setOpenAuthModal } = useModalsStore()
const authStore = useAuthStore()
const { fetchAllGames, allCasinoGames, allGames } = useFetchGames()
const { initSocket } = useSocket()
const { fetchGameJackpots } = useJackpot()
fetchGameJackpots()
const { checkAndLoginWithToken } = useLoginWithToken()
const SITE_DOMAIN = useRuntimeConfig().public.SITE_DOMAIN
const router = useRouter()
const { $isLighthouseBot } = useNuxtApp()
const { jsonLdScript } = useJsonLd()

const { redirect = '' } = route.query
const redirectDelay = 100

const isShowLoginByTokenFailed = ref(false)
const loginByTokenError = ref('')

useHttpServer()

onMounted(async () => {
  useRegisterAddon()
  initSocket()
  if (!allCasinoGames?.value?.length || !allGames?.value?.lenght) {
    fetchAllGames()
  }
  useHttpClient()

  try {
    const success = await checkAndLoginWithToken()
    if (success) {
      setTimeout(() => {
        router.push(redirect || RoutesEnum.Home)
      }, redirectDelay)
    }
  } catch (error) {
    isShowLoginByTokenFailed.value = true
    loginByTokenError.value = error.message
  }
})

useSeoMeta({
  title: () => currentMeta.value.meta_title,
  ogTitle: () => currentMeta.value.meta_title,
  description: () => currentMeta.value.meta_description,
  ogDescription: () => currentMeta.value.meta_description,
  ogUrl: () => SITE_DOMAIN + route.fullPath.replace(/^\/+/, ''),
  twitterCard: () => 'summary_large_image',
  twitterDescription: () => currentMeta.value.meta_description,
  twitterTitle: () => currentMeta.value.meta_title,
  keywords: () => currentMeta.value.meta_keywords,
})

useHead({
  link: [
    {
      rel: 'canonical',
      href: SITE_DOMAIN + route.path.replace(/^\/+/, ''),
    },
  ],
  script: [
    !$isLighthouseBot
      ? {
          src: '/js/millicast.umd.js',
          type: 'text/javascript',
          defer: true,
          rel: 'preload',
        }
      : null,
    !$isLighthouseBot
      ? {
          src: '/js/nanoplayer.4.min.js',
          type: 'text/javascript',
          defer: true,
          rel: 'preload',
        }
      : null,
    jsonLdScript,
  ],
})

watch(
  () => route.path,
  (value) => {
    const ROUTER_REQUIRED_LOGIN = [
      ...LOGIN_REQUIRED_REDIRECT,
      IFrameGameURLEnum.ESPORTS,
      IFrameGameURLEnum.VIRTUAL_SPORTS,
    ]

    if (!isLogged.value && ROUTER_REQUIRED_LOGIN.includes(value)) {
      router.push(RoutesEnum.Home)

      authStore.setSelectedAuthTab(AuthTabEnum.Login)
      setOpenAuthModal(true)
      return
    }
  },
  { immediate: true },
)

watch(
  () => route.query,
  (value) => {
    if (isLogged.value) {
      return
    }

    if (value.modal === MODAL_LOGIN) {
      authStore.setSelectedAuthTab(AuthTabEnum.Login)
      setOpenAuthModal(true)
      return
    }

    if (value.modal === MODAL_SIGN_UP) {
      authStore.setSelectedAuthTab(AuthTabEnum.Register)
      setOpenAuthModal(true)
    }
  },
  { immediate: true },
)
</script>
<template>
  <NuxtLayout :name="displayedLayout">
    <BaseConfirm
      v-model="isShowLoginByTokenFailed"
      title="Thất bại"
      :description="loginByTokenError"
      confirm-label="Đóng"
      image="/images/popup/failed.svg"
      @on-confirm="isShowLoginByTokenFailed = false"
    />
    <NuxtPage />
  </NuxtLayout>
</template>
<style lang="scss">
@import '/assets/icomoon/style.css';
@import '/assets/styles/index.scss';
</style>
